/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Login from '../views/Login.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Login',
    component: Login,
    meta: {
      title: 'Login - Short Action Customs, LLC',
      requiresLogin: false,
      employeeOnly: false,
      showFooter: true
    },
    props: (route) => ({
      returnUrl: route.query.returnUrl ?? ''
    })
  },
  {
    path: '/create-account',
    name: 'CreateAccount',
    component: () => import('../views/CreateAccount.vue'),
    meta: {
      title: 'Create Account - Short Action Customs, LLC',
      requiresLogin: false,
      employeeOnly: false,
      showFooter: true
    }
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: () => import('../views/ChangePassword.vue'),
    meta: {
      title: 'Change Password - Short Action Customs, LLC',
      requiresLogin: true,
      employeeOnly: false,
      showFooter: true
    }
  },
  {
    path: '/my-account',
    name: 'MyAccount',
    component: () => import('../views/MyAccount.vue'),
    meta: {
      title: 'My Account - Short Action Customs, LLC',
      requiresLogin: true,
      employeeOnly: false,
      showFooter: true
    }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('../views/ForgotPassword.vue'),
    meta: {
      title: 'Forgot Password - Short Action Customs, LLC',
      requiresLogin: false,
      employeeOnly: false,
      showFooter: true
    },
    props: (route) => ({
      email: route.query.email ?? ''
    })
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('../views/ResetPassword.vue'),
    meta: {
      title: 'Reset Password - Short Action Customs, LLC',
      requiresLogin: false,
      employeeOnly: false,
      showFooter: true
    },
    props: (route) => ({
      id: route.query.id,
      token: route.query.token
    })
  },
  {
    path: '/email-confirmation',
    name: 'EmailConfirmation',
    component: () => import('../views/EmailConfirmation.vue'),
    meta: {
      title: 'Email Confirmation - Short Action Customs, LLC',
      requiresLogin: false,
      employeeOnly: false,
      showFooter: true
    },
    props: (route) => ({
      id: route.query.id,
      token: route.query.token
    })
  },
  {
    path: '/send-email-confirmation',
    name: 'SendEmailConfirmation',
    component: () => import('../views/SendEmailConfirmation.vue'),
    meta: {
      title: 'Send Email Confirmation - Short Action Customs, LLC',
      requiresLogin: false,
      employeeOnly: false,
      showFooter: true
    },
    props: (route) => ({
      email: route.query.email ?? ''
    })
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/Dashboard.vue'),
    meta: {
      title: 'Dashboard - Short Action Customs, LLC',
      requiresLogin: true,
      employeeOnly: true,
      showFooter: false
    }
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('../views/Users.vue'),
    meta: {
      title: 'Users - Short Action Customs, LLC',
      requiresLogin: true,
      employeeOnly: true,
      showFooter: false
    }
  },
  {
    path: '/calibers',
    name: 'Calibers',
    component: () => import('../views/Calibers.vue'),
    meta: {
      title: 'Calibers - Short Action Customs, LLC',
      requiresLogin: true,
      employeeOnly: true,
      showFooter: false
    }
  },
  {
    path: '/caliber/:id',
    name: 'Caliber',
    component: () => import('../views/Caliber.vue'),
    meta: {
      title: 'Create Caliber - Short Action Customs, LLC',
      requiresLogin: true,
      employeeOnly: true,
      showFooter: false
    },
    props: (route) => ({
      id: Number(route.params.id)
    })
  },
  {
    path: '/not-found',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue'),
    meta: {
      title: 'Not Found - Short Action Customs, LLC',
      requiresLogin: true,
      employeeOnly: false,
      showFooter: true
    }
  },
  {
    path: '/suppliers',
    name: 'Suppliers',
    component: () => import('../views/Suppliers.vue'),
    meta: {
      title: 'Suppliers - Short Action Customs, LLC',
      requiresLogin: true,
      employeeOnly: true,
      showFooter: false
    }
  },
  {
    path: '/supplier/:id',
    name: 'Supplier',
    component: () => import('../views/Supplier.vue'),
    meta: {
      title: 'Create Supplier - Short Action Customs, LLC',
      requiresLogin: true,
      employeeOnly: true,
      showFooter: false
    },
    props: (route) => ({
      id: Number(route.params.id)
    })
  },
  {
    path: '/manufacturers',
    name: 'Manufacturers',
    component: () => import('../views/Manufacturers.vue'),
    meta: {
      title: 'Manufacturers - Short Action Customs, LLC',
      requiresLogin: true,
      employeeOnly: true,
      showFooter: false
    }
  },
  {
    path: '/manufacturer/:id',
    name: 'Manufacturer',
    component: () => import('../views/Manufacturer.vue'),
    meta: {
      title: 'Create Manufacturer - Short Action Customs, LLC',
      requiresLogin: true,
      employeeOnly: true,
      showFooter: false
    },
    props: (route) => ({
      id: Number(route.params.id)
    })
  },
  {
    path: '/customers',
    name: 'Customers',
    component: () => import('../views/Customers.vue'),
    meta: {
      title: 'Customers - Short Action Customs, LLC',
      requiresLogin: true,
      employeeOnly: true,
      showFooter: false
    }
  },
  {
    path: '/customer/:id',
    name: 'Customer',
    component: () => import('../views/Customer.vue'),
    meta: {
      title: 'Create Customer - Short Action Customs, LLC',
      requiresLogin: true,
      employeeOnly: true,
      showFooter: false
    },
    props: (route) => ({
      id: Number(route.params.id)
    })
  },
  {
    path: '/inventory-types',
    name: 'InventoryTypes',
    component: () => import('../views/InventoryTypes.vue'),
    meta: {
      title: 'Inventory Types - Short Action Customs, LLC',
      requiresLogin: true,
      employeeOnly: true,
      showFooter: false
    }
  },
  {
    path: '/inventory-type/:id',
    name: 'InventoryType',
    component: () => import('../views/InventoryType.vue'),
    meta: {
      title: 'Create Inventory Type - Short Action Customs, LLC',
      requiresLogin: true,
      employeeOnly: true,
      showFooter: false
    },
    props: (route) => ({
      id: Number(route.params.id)
    })
  },
  {
    path: '/inventory',
    name: 'Inventory',
    component: () => import('../views/Inventory.vue'),
    meta: {
      title: 'Inventory - Short Action Customs, LLC',
      requiresLogin: true,
      employeeOnly: true,
      showFooter: false
    }
  },
  {
    path: '/inventory/:id',
    name: 'InventoryItem',
    component: () => import('../views/InventoryItem.vue'),
    meta: {
      title: 'Create Inventory Item - Short Action Customs, LLC',
      requiresLogin: true,
      employeeOnly: true,
      showFooter: false
    },
    props: (route) => ({
      id: Number(route.params.id)
    })
  },
  {
    path: '/build-types',
    name: 'BuildTypes',
    component: () => import('../views/BuildTypes.vue'),
    meta: {
      title: 'Build Types - Short Action Customs, LLC',
      requiresLogin: true,
      employeeOnly: true,
      showFooter: false
    }
  },
  {
    path: '/build-type/:id',
    name: 'BuildType',
    component: () => import('../views/BuildType.vue'),
    meta: {
      title: 'Create Build Type - Short Action Customs, LLC',
      requiresLogin: true,
      employeeOnly: true,
      showFooter: false
    },
    props: (route) => ({
      id: Number(route.params.id)
    })
  },
  {
    path: '/services',
    name: 'Services',
    component: () => import('../views/Services.vue'),
    meta: {
      title: 'Services - Short Action Customs, LLC',
      requiresLogin: true,
      employeeOnly: true,
      showFooter: false
    }
  },
  {
    path: '/service/:id',
    name: 'Service',
    component: () => import('../views/Service.vue'),
    meta: {
      title: 'Create Service - Short Action Customs, LLC',
      requiresLogin: true,
      employeeOnly: true,
      showFooter: false
    },
    props: (route) => ({
      id: Number(route.params.id)
    })
  },
  {
    path: '/purchase-orders',
    name: 'PurchaseOrders',
    component: () => import('../views/PurchaseOrders.vue'),
    meta: {
      title: 'Purchase Orders - Short Action Customs, LLC',
      requiresLogin: true,
      employeeOnly: true,
      showFooter: false
    }
  },
  {
    path: '/purchase-order/:id',
    name: 'PurchaseOrder',
    component: () => import('../views/PurchaseOrder.vue'),
    meta: {
      title: 'Create Purchase Order - Short Action Customs, LLC',
      requiresLogin: true,
      employeeOnly: true,
      showFooter: false
    },
    props: (route) => ({
      id: Number(route.params.id),
      customerId: !route.query.customerId ? 0 : Number(route.query.customerId),
      orderId: !route.query.orderId ? 0 : Number(route.query.orderId),
      orderPartIds: !route.query.orderPartIds ? [] : Array.isArray(route.query.orderPartIds) ? route.query.orderPartIds.map(o => new Number(o)) : [new Number(route.query.orderPartIds)],
      orderPartName: !route.query.orderPartName ? '' : decodeURIComponent(route.query.orderPartName as string),
      orderPartPrice: !route.query.orderPartPrice ? 0 : Number(route.query.orderPartPrice)
    })
  },
  {
    path: '/quotes',
    name: 'Quotes',
    component: () => import('../views/Quotes.vue'),
    meta: {
      title: 'Quotes - Short Action Customs, LLC',
      requiresLogin: true,
      employeeOnly: true,
      showFooter: false
    }
  },
  {
    path: '/quote/:id',
    name: 'Quote',
    component: () => import('../views/Quote.vue'),
    meta: {
      title: 'Create Quote - Short Action Customs, LLC',
      requiresLogin: true,
      employeeOnly: true,
      showFooter: false
    },
    props: (route) => ({
      id: Number(route.params.id)
    })
  },
  {
    path: '/orders',
    name: 'Orders',
    component: () => import('../views/Orders.vue'),
    meta: {
      title: 'Orders - Short Action Customs, LLC',
      requiresLogin: true,
      employeeOnly: true,
      showFooter: false
    }
  },
  {
    path: '/order/:id',
    name: 'Order',
    component: () => import('../views/Order.vue'),
    meta: {
      title: 'Order - Short Action Customs, LLC',
      requiresLogin: true,
      employeeOnly: true,
      showFooter: false
    },
    props: (route) => ({
      id: Number(route.params.id)
    })
  },
  {
    path: '/my-quotes',
    name: 'My Quotes',
    component: () => import('../views/MyQuotes.vue'),
    meta: {
      title: 'My Quotes - Short Action Customs, LLC',
      requiresLogin: true,
      employeeOnly: false,
      showFooter: true
    }
  },
  {
    path: '/my-quote/:id',
    name: 'My Quote',
    component: () => import('../views/MyQuote.vue'),
    meta: {
      title: 'My Quote - Short Action Customs, LLC',
      requiresLogin: true,
      employeeOnly: false,
      showFooter: true
    },
    props: (route) => ({
      id: Number(route.params.id)
    })
  },
  {
    path: '/my-orders',
    name: 'My Orders',
    component: () => import('../views/MyOrders.vue'),
    meta: {
      title: 'My Orders - Short Action Customs, LLC',
      requiresLogin: true,
      employeeOnly: false,
      showFooter: true
    }
  },
  {
    path: '/my-order/:id',
    name: 'My Order',
    component: () => import('../views/MyOrder.vue'),
    meta: {
      title: 'My Order - Short Action Customs, LLC',
      requiresLogin: true,
      employeeOnly: false,
      showFooter: true
    },
    props: (route) => ({
      id: Number(route.params.id)
    })
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue'),
    meta: {
      title: 'Not Found - Short Action Customs, LLC',
      requiresLogin: true,
      employeeOnly: false,
      showFooter: true
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
